// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-ant-select-ppt__item {\n  height: 32px;\n  line-height: 32px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.75);\n}\n.home-ant-select-ppt__item:hover {\n  background: #f0f6ff;\n  cursor: pointer;\n}\n.home-ant-select-ppt__item.selected {\n  color: #0B1019;\n  font-weight: 600;\n  background-color: #e6f7ff !important;\n}\n", ""]);
// Exports
module.exports = exports;
